// Haptics sutiles para dar sensación "nativa" a acciones clave (guardar,
// identificar, confirmar). Degrada en silencio donde no hay soporte.
//
// Nota: `navigator.vibrate` NO está soportado en iOS Safari (que es el objetivo
// principal de la PWA), así que en la práctica solo se sentirá en Android/otros.
// Lo dejamos como mejora progresiva: nunca bloquea ni lanza si no existe.

type HapticPattern = 'light' | 'success' | 'warning' | 'error';

const PATTERNS: Record<HapticPattern, number | number[]> = {
  light: 10,
  success: [12, 40, 12],
  warning: [20, 60, 20],
  error: [40, 80, 40],
};

/** Dispara una vibración si el dispositivo/navegador lo permite. No-op si no. */
export function haptic(pattern: HapticPattern = 'light'): void {
  try {
    if (
      typeof navigator !== 'undefined' &&
      typeof navigator.vibrate === 'function' &&
      // Respeta la preferencia de reducir movimiento como señal de "menos efectos".
      !(
        typeof window !== 'undefined' &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      )
    ) {
      navigator.vibrate(PATTERNS[pattern]);
    }
  } catch {
    // Soporte ausente o bloqueado por política: ignorar.
  }
}
